/**
 * Helper model class to allow safe show/hide of async added objects.
 */
export default class ModalSafe {
    /**
     * Constructor
     * @param promise {Promise<{id: string, hide: function}>}
     */
    constructor(promise) {
        this.object = undefined;
        this.hidden = false;
        promise
            .then((object) => {
                this.object = object;
                if (this.hidden) {
                    this.object.hide();
                }
            })
            .catch(() => false);
    }

    /**
     * Safe hide method
     */
    hide() {
        this.hidden = true;
        if (this.object) {
            this.object.hide();
        }
    }
}